/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S62_Item_3Inputs */

const es_tyc_liability_s62_item_3 = /** @type {(inputs: Tyc_Liability_S62_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilidad que no pueda excluirse ni limitarse por ley aplicable.`)
};

const en_tyc_liability_s62_item_3 = /** @type {(inputs: Tyc_Liability_S62_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liability that cannot be excluded or limited by applicable law.`)
};

/**
* | output |
* | --- |
* | "Liability that cannot be excluded or limited by applicable law." |
*
* @param {Tyc_Liability_S62_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s62_item_3 = /** @type {((inputs?: Tyc_Liability_S62_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S62_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s62_item_3(inputs)
	return en_tyc_liability_s62_item_3(inputs)
});
export { tyc_liability_s62_item_3 as "tyc.liability.s62_item_3" }